import { Button, Grid, MenuItem, Modal, Select, TextField, Typography } from "@mui/material";
import { ObjectType } from "../../Refinery/Objects/types";
import { useMemo, useState } from "react";


export interface AddObjectModalProps {
  open: boolean;
  meshKeys: string[];

  onAdd: (type: ObjectType | "light", name: string, meshKey?: string) => void;
  onClose: () => void;
};

export const AddObjectModal = (props: AddObjectModalProps) => {
  const [addType, setAddType] = useState<ObjectType | "light">(ObjectType.CUBE);
  const [addName, setAddName] = useState<string>("");
  const [meshName, setMeshName] = useState<string>("");

  const canAdd = useMemo(() => {
    if (addType === ObjectType.MESH) {
      return addName && meshName;
    }
    return addName;
  }, [addType, addName, meshName]);

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Grid
        sx={(theme) => ({
          backgroundColor: theme.palette.background.paper,
          borderRadius: 2,
          padding: 3,
          minWidth: 400,
          boxShadow: 24,
        })}
      >
        <Typography variant="h6" color="text.primary" gutterBottom>
          Add New Object
        </Typography>
        <Typography variant="body1" color="text.secondary" gutterBottom>
          Time to add a new object
        </Typography>

        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid size={4}>
            <Select
              fullWidth
              value={addType}
              onChange={(e) => {
                setAddType(e.target.value as ObjectType | "light");
              }}
            >
              <MenuItem value={ObjectType.CUBE}>Cube</MenuItem>
              <MenuItem value={ObjectType.MESH}>Mesh</MenuItem>
              <MenuItem value={ObjectType.PLANE}>Plane</MenuItem>
              {/* TODO - re-add once student template supports sphere */}
              {/* <MenuItem value={ObjectType.SPHERE}>Sphere</MenuItem> */}
              <MenuItem value={"light"}>PointLight</MenuItem>
            </Select>
          </Grid>
          {addType === ObjectType.MESH && (
            <Grid size={4}>
              <Select
                fullWidth
                value={meshName}
                onChange={(e) => {
                  setMeshName(e.target.value);
                }}
              >
                {props.meshKeys.map(m => <MenuItem key={m} value={m}>{m}</MenuItem>)}
              </Select>
            </Grid>
          )}
          <Grid size={4}>
            <TextField
              fullWidth
              label="Name"
              value={addName}
              onChange={(e) => {
                setAddName(e.target.value);
              }}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} justifyContent="flex-end">
          <Grid>
            <Button onClick={props.onClose}>Cancel</Button>
          </Grid>
          <Grid>
            <Button
              variant="contained"
              onClick={() => {
                props.onAdd(addType, addName, meshName);
                setAddName("");
                setAddType(ObjectType.CUBE);
              }}
              disabled={!canAdd}
            >Add</Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  )
}